import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import { authReducer, toaster } from "./auth";
import { loaderReducer } from "./loader";
import { userReducer } from "./userInfo";
import addVehiclesReducer from "./addVehicles";
import dashboardReducer from "./dashboard";
import { workShopReducer } from "./workshop";
import { cartReducer } from "./cart";
import { bookingReducer } from "./booking";
import notificationReducer from "./notifications";

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    auth: authReducer,
    toast: toaster,
    loader: loaderReducer,
    userInfo: userReducer,
    addVehicles: addVehiclesReducer,
    dashboard: dashboardReducer,
    workshop: workShopReducer,
    cart: cartReducer,
    booking: bookingReducer,
    notification: notificationReducer,
  });
